export default __webpack_public_path__ + "static/media/project8.4b75f075.JPG";